// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import ArrowDown from "@ces/XDL/Icons/ArrowDown";
import { fontConfig } from "@ces/XDL/PreStyle/typography";
import { xBaseTheme } from "@ces/XDL/types";
import { color } from "@ces/XDL/Utilities";
import { AccordionSectionPanel } from "@insite/mobius/AccordionSection";
import { AccordionSectionHeaderProps } from "@insite/mobius/AccordionSection/AccordionSectionHeader";
import AccordionSectionPresentationPropsDefault from "@insite/mobius/AccordionSection/presentationProps";
import { IconWrapper } from "@insite/mobius/Icon";
import { css } from "styled-components";

export default {
    defaultProps: {
        mergeCss: true,
    },
    sectionDefaultProps: {
        ...AccordionSectionPresentationPropsDefault,
        mergeCss: true,
        titleTypographyProps: {
            variant: "body",
            forwardAs: "span",
            weight: fontConfig.weight.bold,
            color: "text.main",
            size: 24,
            lineHeight: "30px",
        },
        toggleIconProps: {
            color: "text.link",
            src: ArrowDown,
            size: 15,
        },
        headerProps: {
            css: css`
                background: ${color("common.background")};

                button {
                    padding: 0 0 8px 0;
                    border: none;
                    border-bottom: 1px solid ${color("common.border")};
                    background: ${color("common.background")};
                }

                &&& button,
                &&& ${/* sc-selector */ AccordionSectionPanel} + & button {
                    &:focus {
                        border: none;
                        border-bottom: 1px solid ${color("common.border")};
                        background: ${color("common.background")};
                        padding: 0 0 8px 0;
                        outline-width: 0;
                    }
                }

                ${({ expanded }: AccordionSectionHeaderProps) =>
                    !expanded &&
                    css`
                        &&& button,
                        &&& button:focus {
                            margin-bottom: 32px;
                        }

                        &&& button,
                        &&& button:focus,
                        ${AccordionSectionPanel} + & button:focus {
                            border-bottom-color: ${color("common.border")};
                        }
                    `}

                ${IconWrapper} {
                    &:hover,
                    &:focus {
                        color: ${color("common.ui8")};
                    }
                }
            `,
        },
        panelProps: {
            css: css`
                border: none;
                padding: 12px 0 32px 0;
                font-size: 16px;
                line-height: 26px;
                color: ${color("common.ui6")};
            `,
        },
    },
} as xBaseTheme["accordion"];
